module.exports = __webpack_public_path__ + "img/boxbg.8d0f70f1.png";